import { Routes } from '@angular/router';
import { authGuard, noAuthGuard, roleGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layout/layout/layout.component';
import { AccessdeniedComponent } from './shared/components/accessdenied/accessdenied.component';
import { NotfoundComponent } from './shared/components/notfound/notfound.component';
import { Dashboard } from './modules/dashboard/dashboard';
import { nfcAuthGuard } from './core/guards/nfc-auth.guard';
import { AccountComponent } from './modules/dashboard/account/account.component';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./auth/auth.routes')
    },
    {
        path: 'sys',
        component: LayoutComponent,
        // 🔥 IMPORTANTE: Aplicar AMBOS guards en el orden correcto
        // 1️⃣ authGuard - Verifica autenticación básica
        // 2️⃣ nfcAuthGuard - Verifica NFC si el usuario lo requiere
        canActivate: [authGuard, nfcAuthGuard],
        children: [
            {
                path: 'dashboard',
                data: { breadcrumb: 'Inicio' },
                component: Dashboard
            },
            {
                path: 'profile',
                component: AccountComponent
            },
            {
                path: 'identity',
                // Para rutas hijas también puedes aplicar guards adicionales
                canActivate: [roleGuard, nfcAuthGuard],
                data: { roles: ['Encargado', 'Radiólogo', 'delivery_person', 'warehouse_operator', 'root', 'Secretaria'] },
                loadChildren: () => import('./modules/identity/views/identity.routes')
            },
            {
                path: 'settings',
                // Para rutas hijas también puedes aplicar guards adicionales
                canActivate: [roleGuard, nfcAuthGuard],
                data: { roles: ['customer', 'admin', 'manager', 'delivery_person', 'warehouse_operator', 'root'] },
                loadChildren: () => import('./modules/settings/views/settings.routes')
            },
            {
                path: 'cashier',

                loadChildren: () => import('./modules/cashier/views/cashier.routes')
            },
            {
                path: 'cashier-reports',
                loadChildren: () => import('./modules/cashier-reports/views/cashier-reports.routes')
            },
            {
                path: 'clinical',
                canActivate: [roleGuard, nfcAuthGuard],
                data: { roles: ['Secretaria', 'Encargado', 'Radiólogo', 'delivery_person', 'warehouse_operator', 'root'] },
                loadChildren: () => import('./modules/clinical-care/views/clinical-care.routes')
            }
        ]
    },

    {
        path: 'auth',
        canActivate: [noAuthGuard],
        loadChildren: () => import('./auth/auth.routes')
    },
    { path: 'notfound', component: NotfoundComponent },
    { path: 'denied', component: AccessdeniedComponent },
    { path: '**', redirectTo: '/notfound' }
];
